import * as React from "react"
import styled from "styled-components"
import {Col} from "react-bootstrap"

interface ColProps extends Col.ColProps {
  paddingRight?: boolean
  marginBottom?: boolean
}

export const Day = styled(({paddingRight, marginBottom, ...rest}: ColProps) => <Col {...rest} />)`
  .form-group {
    ${({marginBottom}) => (marginBottom ? "margin-bottom: 16px;" : "margin-bottom: 0px;")}
  }
  ${({paddingRight}) => paddingRight && "padding-right: 5px;"}
`

export const Month = styled(({paddingRight, marginBottom, ...rest}: ColProps) => <Col {...rest} />)`
  .form-group {
    ${({marginBottom}) => (marginBottom ? "margin-bottom: 16px;" : "margin-bottom: 0px;")}
  }
  ${({paddingRight}) => paddingRight && "padding-right: 5px;"}
  padding-left: 5px;
`

export const Year = styled(({marginBottom, ...rest}: ColProps) => <Col {...rest} />)`
  .form-group {
    ${({marginBottom}) => (marginBottom ? "margin-bottom: 16px;" : "margin-bottom: 0px;")}
  }
  padding-left: 5px;
`
